// @codekit-prepend "../../../node_modules/zepto/src/zepto.js"
// @codekit-prepend "../../../node_modules/zepto/src/event.js"
// @codekit-prepend "../../../node_modules/zepto/src/form.js"
// @codekit-prepend "../../../node_modules/zepto/src/ajax.js"
// @codekit-prepend "../../../node_modules/zepto/src/ie.js"
// @codekit-prepend "../../../node_modules/zepto/src/data.js"

// @codekit-prepend "lib/keycode.js"
// @codekit-prepend "lib/slugify.js"
// @codekit-prepend "lib/simple-select.js"
// @codekit-prepend "lib/modal.js"
// @codekit-prepend "lib/autocomplete.js"
// @codekit-prepend "lib/validate-email.js"

$('select:not(.segmented)').simpleSelect();
$('body').addClass('ready');

(function(){
    if ($('#url-input').length > 0) {
        let radios = $('input[name="subject"]');
        radios.on('change', function(){
            $('#url-input').toggleClass('visible', radios.filter(':checked').val() > 1);
        }).trigger('change');
    }
})();

function validateForm(form) {
    form = $(form);
    form.find('input.invalid,textarea.invalid,select.invalid,.input.invalid').removeClass('invalid');
    form.find('input[required],textarea[required],select[required]').each(function(){
        if ($(this).attr('type') == 'email' && !validateEmail($(this).val())) $(this).addClass('invalid');
        else if (!$(this).val()) $(this).addClass('invalid');
    });
    if (form.find('input.invalid,textarea.invalid,select.invalid').length > 0) {
		form.find('input.invalid,textarea.invalid,select.invalid').each(function(){
			$(this).closest('.input').addClass('invalid');
		});
		form.find('input.invalid,textarea.invalid,select.invalid').first().focus();
        $.modal('Formulier onvolledig', 'Gelieve alle velden correct in te vullen.').addButton('Ok').show();
		return false;
	}
    return true;
}

$('form').on('submit', function(event) {
    if (validateForm(this) === false) {
        event.stopImmediatePropagation();
		return false;
    }
});

$(document).on('ajaxError', function(e, xhr, errorType, errorObj){
    if (xhr.responseText) {
        try {
            errorObj = JSON.parse(xhr.responseText);
        } catch (e) {}
    }
    $.error(errorObj);
});

$.fn.ajaxBusy = function() {
    this.removeClass('success').removeClass('failure').addClass('busy');
}

$.fn.ajaxDone = function(success) {
    var element = this;
    element.removeClass('busy').addClass('done').addClass(success ? 'success' : 'failure');
    setTimeout(function() {
        element.removeClass('done');
    }, 2000);
    setTimeout(function() {
        element.removeClass('success').removeClass('failure');
    }, 2500);
};

$.error = function(data) {
    let message = data.message || data.error;
    if (message) $.modal('Fout', message, 'centered').addButton('Ok').show();
    $('form').find('input[type="submit"].ajax,button.ajax').ajaxDone(false);
}
